import ru from './fr.json';
import en from './en.json';
import ua from './ua.json';
import es from './es.json';

export default {
    ru,
    en,
    ua,
    es,
    // eslint-disable-next-line
} as Record<string, any>;
